
import FormatterService from "~/service/FormatterService";
import UserService from "~/service/UserService";
import FinAgentStockMenuCard from '@/components/finagent/FinAgentStockMenuCard';
import { finAgentMenuType } from "@/constants/finAgent";
import { finAgentMenuHandler } from '@/mixins';

    export default {
        name: 'UserMessage',

        components: {
            FinAgentStockMenuCard,
        },

        mixins: [finAgentMenuHandler],

        props: {
            value: {
                type: [Object, Boolean],
                default: false
            },
            standalone: {
                type: Boolean,
                default: false
            }
        },

        emits: ['input'],

        data() {
            return {
                formatter: new FormatterService(),
                menuState: {
                    visible: false,
                    x: 0,
                    y: 0,
                    type: null,
                    data: {}
                },
            }
        },
        created() {
            this.finAgentMenuType = finAgentMenuType;
            this.userService = new UserService(this.$axios);
        },
        methods: {
            async handleResponse(index) {
                try {
                    this.$gtag?.event(
                        'sp_usermessage_select',
                        { id: this.value.id, index: index }
                    );
                    await this.userService.postUserResponse(this.value.id, index);
                    this.$emit('input', null);
                    if (this.value.responseRoutes[index] !== '') {
                        const routeNameToDirect = this.$getTranslatedRouteName(this.value.responseRoutes[index])
                        this.$router.push({ name: routeNameToDirect })
                    }
                } catch (error) {
                    console.error('Error sending response:', error);
                }
            },
            
            updateMenuState(state) {
                if (this.menuState.visible) {
                    return;
                }
                this.menuState = { ...this.menuState, ...state };
            },

            resetMenuState() {
                this.menuState.visible = false;
                this.menuState.type = null;
                this.menuState.data = {};
            },

            handleClickMessageContent(event) {
                const finAgentData = this.handleClickFinAgentContent(event);

                if (finAgentData) {
                    this.updateMenuState(finAgentData);
                }
            },
        },
    }
